module.exports = __webpack_public_path__ + "static/media/close-sidebar.ce0c95ca.svg";